/**
 * 분류는 서버(debate-lab/src/topicRules.js)와 같은 값이어야 한다.
 * 다르면 필터가 아무것도 못 찾는다 — Firestore where 절이 문자열 일치라서
 * 조용히 빈 목록이 나온다.
 *
 * 필터는 사람이 올리는 분류(MANUAL_CATEGORIES)까지 보여 준다. 스포츠는 배치가
 * 만들지 않고 관리자가 올린다.
 */
export const CATEGORIES = ["정의·경계", "고전 딜레마", "기술·노동", "일상 사회", "윤리", "스포츠"];
